import {SocialAccount} from "./licensable_property";

export interface BusinessProfile {
  id?: string;
  name?: string;
  organization_id?: string;
  status?: BusinessProfileStatus;
  industry?: string;
  address_line_1?: string;
  address_line_2?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  website_url?: string;
  social_accounts?: SocialAccount[];
  campaigns?: Campaign[];
  documents?: Document[];
  created_by?: string;
  created_at?: string;
  deleted_by?: string;
  deleted_at?: string;
  rights?: BusinessProfileRight[];
}

export interface Campaign {
  id?: string;
  name?: string;
  start_date?: string;
  end_date?: string;
  summary?: string;
  goal?: string;
  strategy_document_id?: string;
  business_profile_id?: string;
  strategies?: Strategy[];
}

export interface Strategy {
  id?: string;
  name?: string;
  description?: string;
  start_date?: string;
  end_date?: string;
  campaign_id?: string;
  posts?: Post[];
}

export interface Post {
  id?: string;
  name?: string;
  post_date?: string;
  prompt?: string;
  generative_model_id?: string;
  generative_outputs?: GenerativeOutput[];
  caption?: string;
  score?: number;
  social_account_provider?: string;
  script?: string;
}

export interface Document {
  id?: string;
  name?: string;
  content?: string;
  usage?: "BUSINESS_INTELLIGENCE" | "STRATEGY" | "PERSONA";
  created_by?: string;
  created_at?: string;
  updated_by?: string;
  updated_at?: string;
  version?: number;
}

export interface DocumentHistory {
  id?: string;
  document_id?: string;
  content?: string;
  version?: number;
  change_summary?: string;
  created_by?: string;
  created_at?: string;
  updated_by?: string;
  updated_at?: string;
}

export interface DocumentHistory {
  id?: string;
  document_id?: string;
  content?: string;
  version?: number;
  change_summary?: string;
  created_by?: string;
  created_at?: string;
  updated_by?: string;
  updated_at?: string;
}

export enum BusinessProfileStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  TRAINING = "TRAINING",
  FAILED = "FAILED",
  DELETED = "DELETED"
}

export interface GenerativeOutput {
  generative_output_id: string;
  asset_type: string;
  status?: string;
  file_id: string;
  permalink: string;
  created_at: string;
  thumbnail_image?: string;
  task_queue_id?: string;
  // seed?: number
}

export interface BusinessProfileRight {
  id?: string;
  business_profile_id?: string;
  permission?: string;
  user_id?: string;
  organization_id?: string;
}

export interface DeepResearchTask {
    id: string;
    status: "queued" | "processing" | "completed" | "failed";
    name?: string;
    result?: string;
    payload?: string;
    created_at?: string;
    updated_at?: string;
}

export interface DeepResearchWorkflowExecution {
    id: string;
    workflow_id?: string;
    status?: string;
    started_at?: string;
    completed_at?: string;
    created_at?: string;
    updated_at?: string;
    input_data?: {
        provider?: string;
        research_type?: string;
        business_profile_id?: string;
    };
    error_message?: string;
    steps?: {
        id: string;
        name?: string;
        status?: string;
        started_at?: string;
        completed_at?: string;
        workflow_step?: {
            step_name?: string;
        };
        error_message?: string;
    }[];
}